<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2020-12-01 09:23:56
    Description : 素材首页列表
  -->
  <div class="main">
    <div class="page-top">
      <div class="page">
        <el-carousel height="150px">
          <el-carousel-item v-for="(item, i) in imgList" :key="i">
            <img
              :src="item.img"
              :style="{ cursor: item.url ? 'pointer' : '' }"
              @click="open(item.url)"
            />
          </el-carousel-item>
        </el-carousel>
        <el-radio-group v-model="form.type" @change="getList">
          <el-radio-button
            v-for="(item, i) in pageList"
            class="el-radio-button-black"
            :key="i"
            :label="item.value"
          >
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>
        <el-input
          class="search-input"
          placeholder="输入标题进行搜索"
          v-model="form.title"
          @change="getList"
          clearable
        >
        </el-input>
        <div class="gaia-search" @click="getList">
          <i class="el-icon-search"></i>
        </div>
        <div class="filter">
          <div class="filter-item">
            <div class="title">分类：</div>
            <div class="list">
              <div
                class="item"
                v-for="(item, i) in typeList"
                :key="i"
                :class="{ checked: isClassifyChecked(item) }"
                @click="filterClick(item.value, 0)"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
          <div class="filter-item">
            <div class="title">筛选：</div>
            <div class="list">
              <div
                class="item"
                v-for="(item, i) in filterList"
                :key="i"
                :class="{ checked: form.filter === item.value }"
                @click="filterClick(item.value, 1)"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
          <div class="filter-item">
            <div class="title">排序：</div>
            <div class="list">
              <div
                class="item"
                v-for="(item, i) in sortList"
                :key="i"
                :class="{ checked: form.sort === item.value }"
                @click="filterClick(item.value, 2)"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
          <div class="filter-item" v-if="form.type === 'music'">
            <div class="title">类型：</div>
            <div class="list">
              <div
                class="item"
                :class="{ checked: form.musicType === 'audio' }"
                @click="filterClick('audio', 3)"
              >
                音效
              </div>
              <div
                class="item"
                :class="{ checked: form.musicType === 'music' }"
                @click="filterClick('music', 3)"
              >
                音乐
              </div>
            </div>
          </div>
          <div class="filter-item">
            <div class="title">高级：</div>
            <el-select
              v-if="form.type === 'video'"
              v-model="form.vresolution"
              class="el-select-black"
              placeholder="请选择分辨率"
              size="mini"
              @change="getList"
            >
              <el-option label="全部分辨率" :value="0"> </el-option>
              <el-option label="16K" :value="16"> </el-option>
              <el-option label="8K" :value="8"> </el-option>
              <el-option label="4K" :value="4"> </el-option>
              <el-option label="2K" :value="2"> </el-option>
            </el-select>
            <el-select
              v-if="form.type === 'video'"
              v-model="form.vformat"
              class="el-select-black"
              placeholder="请选择格式"
              size="mini"
              @change="getList"
            >
              <el-option label="全部格式" value=""> </el-option>
              <el-option label="mp4" value="mp4"> </el-option>
              <el-option label="MOV" value="MOV"> </el-option>
              <el-option label="MXF" value="MXF"> </el-option>
              <el-option label="MTS" value="MTS"> </el-option>
              <el-option label="R3D" value="R3D"> </el-option>
            </el-select>
            <el-select
              v-if="form.type === 'picture'"
              v-model="form.pformat"
              class="el-select-black"
              placeholder="请选择格式"
              size="mini"
              @change="getList"
            >
              <el-option label="所有格式" value=""> </el-option>
              <el-option label="JPEG" value="jpeg"> </el-option>
              <el-option label="PNG" value="png"> </el-option>
              <el-option label="GIF" value="gif"> </el-option>
            </el-select>
            <el-select
              v-if="form.type === 'picture'"
              v-model="form.pmodel"
              class="el-select-black"
              placeholder="模式"
              size="mini"
              @change="getList"
            >
              <el-option label="所有颜色模式" value=""> </el-option>
              <el-option label="RGB" value="RGB"> </el-option>
              <el-option label="CMYK" value="CMYK"> </el-option>
            </el-select>
            <el-select
              v-if="form.type === 'music'"
              v-model="form.mformat"
              class="el-select-black"
              placeholder="软件版本"
              size="mini"
              @change="getList"
            >
              <el-option label="所有软件版本" value=""> </el-option>
              <el-option label="Adobe Audition" value="Adobe Audition">
              </el-option>
            </el-select>
            <el-select
              v-if="form.type === 'music'"
              v-model="form.mversion"
              class="el-select-black"
              placeholder="软件版本"
              size="mini"
              @change="getList"
            >
              <el-option label="所有格式" value=""> </el-option>
              <el-option label="MP3" value="mp3"> </el-option>
              <el-option label="MP4" value="mp4"> </el-option>
              <el-option label="M4A" value="M4A"> </el-option>
              <el-option label="WAV" value="wav"> </el-option>
            </el-select>
            <el-select
              v-if="form.type === 'template'"
              v-model="form.tversion"
              class="el-select-black"
              placeholder="软件版本"
              size="mini"
              @change="getList"
            >
              <el-option label="所有软件版本" value=""> </el-option>
              <el-option label="AE CS3" value="ae cs3"> </el-option>
              <el-option label="AE CS4" value="ae cs4"> </el-option>
              <el-option label="AE CS5" value="ae cs5"> </el-option>
              <el-option label="AE CS5.5" value="ae cs5.5"> </el-option>
              <el-option label="AE CS6" value="ae cs6"> </el-option>
              <el-option label="AE CC" value="ae cc"> </el-option>
            </el-select>
            <el-select
              v-if="form.type === 'other'"
              v-model="form.oformat"
              class="el-select-black"
              placeholder="文件格式"
              size="mini"
              @change="getList"
            >
              <el-option label="所有格式" value=""> </el-option>
              <el-option label="ZIP" value="zip"> </el-option>
              <el-option label="RAR" value="rar"> </el-option>
              <el-option label="7Z" value="7z"> </el-option>
            </el-select>
            <el-select
              v-if="form.type === 'virtualProperty'"
              v-model="form.vPformat"
              class="el-select-black"
              placeholder="文件格式"
              size="mini"
              @change="getList"
            >
              <el-option label="所有格式" value=""> </el-option>
              <el-option label="ZIP" value="zip"> </el-option>
              <el-option label="RAR" value="rar"> </el-option>
              <el-option label="7Z" value="7z"> </el-option>
            </el-select>
          </div>
          <el-link class="refresh" icon="el-icon-refresh" @click="refresh">
            重置
          </el-link>
        </div>
      </div>
    </div>
    <div class="tags-level page">
      <el-select
        v-if="form.type === 'virtualProperty'"
        v-model="levelKeyword1"
        class="el-select-black"
        size="mini"
        @change="levelList1Change"
      >
        <el-option v-for='item in levelList1' :key='item.value' :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <i v-if="form.type === 'virtualProperty'" class="el-icon-caret-right"></i>
      <el-select
        v-if="form.type === 'virtualProperty'"
        v-model="levelKeyword2"
        class="el-select-black"
        size="mini"
        @change="levelList2Change"
      >
        <el-option v-for='item in levelList2' :key='item.value' :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <i v-if="form.type === 'virtualProperty'" class="el-icon-caret-right"></i>
      <el-select
        v-if="form.type === 'virtualProperty'"
        v-model="levelKeyword3"
        class="el-select-black"
        size="mini"
        @change="levelList3Change"
      >
        <el-option v-for='item in levelList3' :key='item.value' :label="item.label" :value="item.value"> </el-option>
      </el-select>
    </div>
    <div class="works-list page" v-loading="loading">
      <div class="works-length" v-if="form.type !== 'virtualProperty'">所有（{{ form.total }}）</div>
      <div class="works-length" v-else></div>
      <material-card
        v-for="(item, i) in list"
        :key="Math.random()"
        :data="item"
        :showPrice="true"
        @click="cardClick(item.material.id, item.material.contentType)"
      />
      <el-pagination
        layout="prev, pager, next, jumper"
        prev-text="上页"
        next-text="下页"
        :current-page.sync="form.pageIndex"
        :page-size="form.pageSize"
        :total="form.total"
        :small="true"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      >
      </el-pagination>
      <el-divider></el-divider>
    </div>
    <div class="tag-list page">
      <div class="title">常用搜索标签：</div>
      <el-tag
        v-for="(item, i) in tagList"
        :key="i"
        class="gaia-tag"
        type="info"
        effect="plain"
        @click="
          form.title = item;
          getList();
        "
      >
        {{ item }}
      </el-tag>
      <el-divider></el-divider>
    </div>
    <div class="ads page">
      <el-image
        style="width: 100%; height: 130px; cursor: pointer"
        :src="bottomImg"
        fit="cover"
        @click="open(bottomUrl)"
      ></el-image>
    </div>
  </div>
</template>

<script>
import gaiaImgViewer from "@/components/gaia-imgViewer/gaia-imgViewer";
import gaiaImgViewer2 from "@/components/gaia-imgViewer/gaia-imgViewer2";
import gaiaPlayer2 from "@/components/gaia-player/gaia-player2";
import materialCard from "@/components/work-card/material-card";
import { getList } from "@/api/material";
import { getVirtualTags } from '../../api/material'
export default {
  components: {
    gaiaImgViewer,
    gaiaImgViewer2,
    gaiaPlayer2,
    materialCard,
  },
  data() {
    return {
      // imgUrl: "https://image-demo.oss-cn-hangzhou.aliyuncs.com/example.jpg",
      show: false,
      //xml: "https://shop.scxingli.com/static/world.jpg/index.xml",
      // videoId: 1,
      // src:
      //   "https://pub-glb-st.cn-e1.acs-cdn.gaiamount.com/lst/u26/v54/200428-153659/playlist_avc_sdr_3960x3960_src.m3u8",
      imgList: [],
      pageList: [
        { label: "视频素材", value: "video" },
        { label: "图片素材", value: "picture" },
        { label: "音频素材", value: "music" },
        { label: "模板素材", value: "template" },
        { label: '虚拟资产素材', value: 'virtualProperty'},
        { label: "其它素材", value: "other" },
      ],
      typeList: [{ label: "所有分类", value: "" }],
      filterList: [
        { label: "全部", value: "" },
        { label: "免费素材", value: "free" },
        { label: "付费素材", value: "pay" },
        { label: "推荐", value: "recommend" },
      ],
      sortList: [
        { label: "默认", value: "" },
        { label: "最新发布", value: "time" },
        { label: "价格高到低", value: "top" },
        { label: "价格低到高", value: "low" },
        { label: "最多下载", value: "down" },
        { label: "最多收藏", value: "collect" },
      ],
      tagList: ["标签1", "标签2", "标签3", "标签4", "标签4"],
      resolutionChecked: "",
      list: [],
      loading: false,
      form: {
        type: "video",
        filter: "", // 筛选条件
        keyword: "", // 分类标签
        sort: "", // 排序
        title: "", // 标题搜索
        vresolution: 0, // 分辨率
        vformat: "", // 视频格式
        pformat: "", // 图片格式
        pmodel: "", // 颜色模式
        mformat: "", // 音频格式
        mversion: "", // 音频软件版本
        tversion: "", // 模板软件版本
        oformat: "", // 其它格式
        musicType: "audio", // 音频分类
        pageIndex: 1,
        pageSize: 16,
        total: 0,
        vPformat: ""
      },
      bottomImg:
        "https://qw.gaiamount.com/smallFile/479785/15753709953570aee.jpg",
      bottomUrl: "",
      levelKeyword1: '',
      levelKeyword2: '',
      levelKeyword3: '',
      virtualKeyword: '',
      levelList1: [{
        label: '全部',
        value: ''
      }],
      levelList2: [{
        label: '全部',
        value: ''
      }],
      levelList3: [{
        label: '全部',
        value: ''
      }],
    };
  },
  created() {
    this.form.type = this.$route.query.type || "video";
    this.form.title = this.$route.query.title || "";
    this.getVirtualTags()
    this.getList();
  },
  methods: {
    open(url) {
      if (url) {
        window.open(url);
      }
    },
    openDialog(name) {
      this.xml = `https://pub-glb-st.cn-e1.acs-cdn.gaiamount.com/dzi/u15/v277/210120-094300/img_500x314_src.dzi`;
      this.show = true;
    },
    filterClick(value, i) {
      switch (i) {
        case 0:
          if (this.form.type === 'virtualProperty') {
            this.levelKeyword1 = value
            this.levelList1Change()
          } else {
            this.form.keyword = value;
          }
          break;
        case 1:
          this.form.filter = value;
          break;
        case 2:
          this.form.sort = value;
          break;
        case 3:
          this.form.musicType = value;
          break;
      }
      this.getList();
    },
    refresh() {
      this.form.title = "";
      this.form.type = this.pageList[0].value;
      this.form.keyword = this.typeList[0].value;
      this.form.filter = this.filterList[0].value;
      this.form.sort = this.sortList[0].value;
      this.resolutionChecked = "";
      this.form.vformat = "";
      this.form.vPformat = "";
      this.form.pformat = "";
      this.form.pmodel = "";
      this.form.mformat = "";
      this.form.mversion = "";
      this.form.tversion = "";
      this.form.oformat = "";
      this.getList();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList(val);
    },
    cardClick(i, contentType) {
      console.log(`点击了 ${i}`);
      // this.$router.push(
      //   `/gaia-material/detail/${i}?contentType=${contentType}`
      // );
      let routeData = this.$router.resolve(
        `/gaia-material/detail/${i}?contentType=${contentType}`
      );
      window.open(routeData.href, "_blank");
    },
    async getVirtualTags(){
      const res = await getVirtualTags()
      if (res.contentList) {
        this.levelList1 = this.levelList1.concat(res.contentList.map(it => ({
          ...it,
          label: it.keyword,
          value: it.keyword,
        })))
      }
    },
    levelList1Change() {
      this.levelKeyword2 = ''
      this.levelList2 = [{
        label: '全部',
        value: ''
      }]
      this.levelKeyword3 = ''
      this.levelList3 = [{
        label: '全部',
        value: ''
      }]
      if(this.levelKeyword1 === '') {
        this.virtualKeyword = this.levelKeyword1
        this.getList()
      } else {
        this.levelList2 = this.levelList2.concat(this.levelList1.find(it => it.keyword === this.levelKeyword1).contentList.map(i => {
          return {
            ...i,
            label: i.keyword,
            value: i.keyword,
          }
        })).filter(it => Boolean(it.label))
        this.virtualKeyword = this.levelKeyword1
        this.getList()
      }
    },
    levelList2Change() {
      this.levelKeyword3 = ''
      this.levelList3 = [{
        label: '全部',
        value: ''
      }]
      this.levelList3 = this.levelList3.concat(this.levelList1.find(it => it.keyword === this.levelKeyword1).contentList.find(it => it.keyword === this.levelKeyword2).contentList.map(i => {
        return {
          ...i,
          label: i.keyword,
          value: i.keyword,
        }
      })).filter(it => Boolean(it.label))
      if (this.levelKeyword2 === '') {
        this.virtualKeyword = this.levelKeyword1
        this.getList()
      } else {
        this.virtualKeyword = [this.levelKeyword1, this.levelKeyword2].join(';')
        this.getList()
      }
    },
    levelList3Change() {
      if (this.levelKeyword3 === '') {
        this.virtualKeyword = [this.levelKeyword1, this.levelKeyword2].join(';')
        this.getList()
      } else {
        this.virtualKeyword = [this.levelKeyword1, this.levelKeyword2, this.levelKeyword3].join(';')
        this.getList()
      }
    },
    refreshList() {
      this.levelList1 = [{
        label: '全部',
        value: ''
      }]
        this.levelList2 = [{
        label: '全部',
        value: ''
      }]
        this.levelList3 = [{
        label: '全部',
        value: ''
      }]
    },
    getList(pageIndex = 1) {
      this.form.pageIndex = pageIndex;
      if (isNaN(pageIndex)) {
        this.form.pageIndex = 1;
      }
      this.loading = true;
      if (this.form.type === 'virtualProperty') {
        this.form.keyword = this.virtualKeyword
      }
      getList(this.form).then((res) => {
        this.loading = false;
        console.log(res);
        this.list = res.materialList;
        this.form = { ...this.form, ...res.page };
        // materialKeywordList_top
        if (this.form.type === 'virtualProperty') {
          let arr = [...this.levelList1]
          arr.shift()
          this.typeList = arr
        } else {
          this.typeList = res.materialKeywordList_top.map((el) => {
            return {
              value: el.content,
              label: el.content,
            };
          });
        }
        this.typeList.unshift({
          value: "",
          label: "所有分类",
        });
        this.tagList = res.materialKeywordList_down.map((el) => {
          return el.content;
        });
        this.imgList = res.rotationChartMaterialList_top.map((el) => {
          return {
            img: process.env.VUE_APP_RESOURCES_URL + el.picture,
            url: el.url,
          };
        });
        if (res.rotationChartMaterialList_down[0]) {
          this.bottomImg =
            process.env.VUE_APP_RESOURCES_URL +
            res.rotationChartMaterialList_down[0].picture;
          this.bottomUrl = res.rotationChartMaterialList_down[0].url;
        }
      });
    },
    isClassifyChecked(item){
      if (this.form.type === 'virtualProperty') {
        return this.levelKeyword1 === item.value
      } else {
        return this.form.keyword === item.value
      }
    }
  },
};
</script>
<style lang="less">
</style>
<style lang="less" scoped>
@width: 1200px;
@min-width: 1300px;

.main {
  min-width: @min-width;
  padding-top: 70px;
  background: #ededed;
  padding-bottom: 100px;
}

.page-top {
  width: 100%;
  min-width: @min-width;
  padding: 24px 0 1px;
  margin-bottom: 30px;
  // height: 380px;
  background: #222222;
  box-sizing: border-box;
}

.search-input {
  width: 550px;
  float: right;
}

.gaia-search {
  position: relative;
  top: -40px;
  left: 1080px;
  width: 120px;
  height: 40px;
  background: linear-gradient(90deg, #ff5b67 0%, #ff464c 100%, #ff464c 100%);
  border-radius: 0px 8px 8px 0px;
  color: #ffffff;
  text-align: center;
  padding-top: 8px;
  cursor: pointer;
  transition: all 0.4s;
}
.gaia-search:active {
  background: linear-gradient(90deg, #ca4851 0%, #c2363b 100%, #c4373b 100%);
  transition: all 0.4s;
}

.filter {
  margin: 0px 0 30px;
  font-size: 12px;
  user-select: none;
  .filter-item {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    margin-bottom: 20px;
    .title {
      width: 4%;
      font-weight: bold;
      color: #999999;
    }
    .list {
      width: 95%;
      .item {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        margin: 0 6px;
        border-radius: 4px;
        color: #999999;
        cursor: pointer;
      }
      .item.checked {
        color: #ffffff;
        background: linear-gradient(135deg, #fc765e, #f7515b);
      }
    }
  }
}

.tags-level {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.refresh {
  float: right;
  margin-top: -36px;
  color: #999999;
}

.works-list {
  width: @width;
  min-width: @min-width;
  margin: 0 auto;
  .works-length {
    font-weight: bold;
  }
  .item {
    margin: 10px 1.333% 36px 0;
  }
  .item:nth-child(4n + 1) {
    margin-right: 0;
  }
}

.tag-list {
  margin-top: 30px;
  .title {
    display: inline-block;
    font-weight: bold;
    font-size: 14px;
  }
  .el-tag {
    margin: 0px 8px 8px 0px;
    cursor: pointer;
    user-select: none;
  }
}

.ads {
  height: 200px;
}
</style>

<style lang="less">
@width: 1200px;

.el-carousel {
  border-radius: 10px;
  margin-bottom: 24px;
}

.el-radio-button:first-child .el-radio-button__inner {
  border-radius: 10px 0 0 10px;
}

.el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0 10px 10px 0;
}
.filter-item {
  .el-select {
    margin-right: 20px;
  }
}
/**
 * 搜索框ipnut
 */
.search-input.el-input {
  .el-input__inner {
    border-radius: 10px;
  }
}

/**
 * 分页组件覆盖样式
 */
.el-pagination {
  text-align: center;
  margin: 60px 0 50px;
  .btn-next,
  .btn-prev {
    border-radius: 20px;
    height: 32px;
    padding: 2px 10px;
    margin: 0 10px;
    color: #fff;
    background-color: #909399;
    border-color: #909399;
  }
  .el-pager {
    .number,
    li:last-child {
      width: 32px;
      height: 32px;
      line-height: 32px;
      border-radius: 50%;
      border: 1px solid #717171;
    }
    .number.active {
      background: #ff565c;
      color: #fff;
      border: 1px solid #ff565c;
    }
  }
  button:hover {
    color: #ffffff;
    background: #a9acb3;
  }
  span:not([class*="suffix"]) {
    height: 32px;
    line-height: 32px;
  }
  li.btn-quicknext {
    line-height: 32px;
    height: 32px;
  }
}
</style>
